import React, {ReactNode} from "react"
import {I18nGlobals} from "../translation/i18nInterface";
import Translate from "../translation/Translate";
import DomHelper from "../helper/DomHelper";
import FunctionHelper from "../helper/FunctionHelper";
import Icon from "./Icon";
import PortalPureComponent from "./PortalPureComponent";

/**
 * The type of info icon to show
 */
export enum InfoType {
	Info = "info",
	Help = "help"
}

/**
 * The properties for an {@link Info} component
 */
interface InfoProperties extends I18nGlobals {
	type?: InfoType;
	data: string,
	options?: any,
	markdown?: boolean,
	position?: 'top' | 'bottom' | 'left' | 'right'
}

/**
 * This component is a wrapper for the {@link Icon} element to call this class with predefined {@link InfoType} icons
 * and translation key
 */
export default class Info extends PortalPureComponent<InfoProperties, any> {
	private id: string;

	/**
	 * Constructs an {@link Info} instance
	 */
	constructor(props: Readonly<InfoProperties>) {
		super(props);

		this.id = DomHelper.generateUUID();
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		if (!FunctionHelper.exists(this.props.data) || FunctionHelper.isEmpty(this.props.data)) {
			// don't render if no translation key is given
			return null;
		}

		let className: Array<string> = ["dialog-info", "info-tooltip-" + this.id];

		switch (this.props.type) {
			case InfoType.Help:
				className.push("icon");
				className.push("icon-help");
				className.push("circle");
				break;
			default:
				className.push("icon");
				className.push("icon-info");
				break;
		}

		return (
			<Icon icon={className.join(" ")} position={FunctionHelper.applyValue(this.props.position, "top")}
				  tooltipClass="info-tooltip"
				  tooltip={
					  <Translate {...this.props} data={this.props.data} namespace={this.props.options?.ns}
								 values={this.props.options} markdown={this.props.markdown}/>
				  }/>
		);
	}
}